module.exports = __webpack_public_path__ + "static/img/3.1980b07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/3.png
// module id = HhmB
// module chunks = 0